import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { initQueryClient } from '@ts-rest/react-query';
import React, { useState } from 'react';
import env from 'react-dotenv';

import { contract } from '@common/tsrest';

export const tsrestClient = initQueryClient(contract, {
  baseUrl: env.API_URL || '',
  baseHeaders: {},
});
export const TsrestProvider = ({ children }: { children: React.ReactNode }) => {
  const [queryClient] = useState(() => new QueryClient());
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
